import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isExistSoftVersion
    ? _c(
        "div",
        [
          _c(
            VMenu,
            {
              attrs: {
                "open-on-hover": "",
                "offset-y": "",
                "close-on-content-click": false,
                "open-on-click": false,
                "close-delay": 200,
                "max-width": "380",
                "z-index": "110",
                "nudge-left": (380 - 28) / 2,
                "nudge-top": "8",
                transition: "fade-transition",
                "content-class": "soft-version-icon-tooltip",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "span",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass:
                                  "soft-version-icon__trigger cursor-pointer",
                                attrs: { "data-qa": "soft_version_icon" },
                              },
                              "span",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(_setup.SoftVersionImage, {
                              attrs: { image: _setup.softData.image },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                698658519
              ),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column ga-4" }, [
                _c("div", { staticClass: "text-subtitle-1 text--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.tStatic("Пользуется порталом с версией")) +
                      " " +
                      _vm._s(_setup.softData.translate) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-body-1 text--text d-flex flex-column ga-3",
                  },
                  _vm._l(_setup.listBenefits, function (benefit) {
                    return _c("div", { key: benefit }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.getFirstLetterUpper(_setup.tStatic(benefit))
                          ) +
                          "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }